<kendo-window
    [(state)]="windowState"
    [(width)]="windowWidth"
    [(height)]="windowHeight"
    (close)="close()"
>
    <kendo-window-titlebar>
        <app-window-titlebar
            [title]="customMessagesService.translate('confirmation_delete_titre')"
            [(state)]="windowState"
            (closeWindow)="close()"
        ></app-window-titlebar>
    </kendo-window-titlebar>
    <p>{{ message() }}</p>
    @if (messageChild() !== '') {
        <p>{{ messageChild() }}</p>
    }
    <button
        type="button"
        (click)="oui()"
    >
        {{ customMessagesService.translate('oui') }}
    </button>
    <button
        type="button"
        (click)="close()"
    >
        {{ customMessagesService.translate('non') }}
    </button>
</kendo-window>
